import { SingleSelectDropdown } from '@abtasty/design-system';
import { changeTest } from '../../../helpers';
import { QATest } from '@src/application/modules/tag/shared/tag/types';
import { TestStatusRejected } from '@src/application/modules/tag/shared/tag/serializedTagTypes';

export const ExclusionGroupDropdown = ({ test }: { test: QATest }) => {
  if (!test.exclusionGroup) return null;
  return (
    <SingleSelectDropdown
      className="single-select-dropdown"
      selectorType="outlined32"
      onChange={({ value }) => changeTest(test.exclusionGroup!.id, test.parent ? test.parent.id : test.id, value.id)}
      options={[
        {
          label: test.exclusionGroup?.name ?? '',
          options: Object.values(test.exclusionGroup?.tests).map((test) => ({
            label: test.name,
            value: test,
            isDisabled: test.status === TestStatusRejected.rejected,
          })),
        },
      ]}
      value={{
        value: test.exclusionGroup.tests[test.parent ? test.parent.id : test.id],
        label: test.name,
      }}
    />
  );
};
